/**
 * Utilitário para registrar e gerenciar Service Worker.
 *
 * O SW de app shell (/sw.js) fica desabilitado: cache-first em /static e
 * precache de '/' fazia usuários ficarem em builds antigos após deploy.
 * Aqui apenas limpamos registros/caches legados; push usa /sw-notifications.js.
 */

function isAppShellServiceWorker(scriptURL: string): boolean {
  try {
    const path = new URL(scriptURL).pathname;
    return path === '/sw.js' || path.endsWith('/sw.js');
  } catch {
    return scriptURL.includes('/sw.js') && !scriptURL.includes('sw-notifications');
  }
}

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  // Não registrar o SW de shell. Remover qualquer /sw.js legado ainda ativo.
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      registrations.forEach((registration) => {
        const script =
          registration.active?.scriptURL ||
          registration.waiting?.scriptURL ||
          registration.installing?.scriptURL ||
          '';
        if (script && isAppShellServiceWorker(script)) {
          registration.unregister().then((ok) => {
            if (ok) {
              console.log('ℹ️ Service Worker de app shell (/sw.js) desregistrado');
            }
          });
        }
      });
    })
    .catch(() => {
      /* ignore */
    });

  if ('caches' in window) {
    caches
      .keys()
      .then((keys) =>
        Promise.all(
          keys
            .filter(
              (k) =>
                k.startsWith('upclinic-settings') ||
                k.startsWith('upclinic-runtime')
            )
            .map((k) => caches.delete(k))
        )
      )
      .catch(() => {
        /* ignore */
      });
  }
}

export function unregisterServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) =>
      Promise.all(
        registrations.map((registration) => {
          const script =
            registration.active?.scriptURL ||
            registration.waiting?.scriptURL ||
            registration.installing?.scriptURL ||
            '';
          if (script && isAppShellServiceWorker(script)) {
            return registration.unregister();
          }
          return Promise.resolve(false);
        })
      )
    )
    .catch((error) => {
      console.error('❌ Erro ao desregistrar Service Worker:', error);
    });
}

// Verificar status offline/online
export function setupOfflineDetection() {
  window.addEventListener('online', () => {
    console.log('✅ Conexão restaurada');
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ type: 'SYNC' });
    }
  });

  window.addEventListener('offline', () => {
    console.log('⚠️ Conexão perdida - Modo offline ativado');
  });
}
